import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
var topicParams = {
  'filter[hot]': 1,
  'filter[content]': '',
  perPage: 5,
  page: 1
};
// const threadListParams = { perPage: 10, page: 1, 'filter[essence]': 0, 'filter[attention]': 0, 'filter[sort]': 3, sequence: 0 }
import $ from 'jquery';
import getPx from '@/utils/getPx';
import { recommendKeywords, topicList } from '@/api/mg';
export default {
  name: 'Search',
  data: function data() {
    return {
      findList: [],
      searchArr: [],
      inputValue: '',
      isEmpty: true,
      transitionName: '',
      arr: ['All', 'Club', 'Activity', 'News'],
      activeName: 'All',
      isResults: false,
      value: '',
      isInput: false,
      historySearchList: JSON.parse(localStorage.getItem('historySearchList')) || [],
      hotSearchList: [],
      hotTopicList: []
    };
  },
  watch: {
    '$route': function $route(to, from) {
      var isBack = this.$router.isBack; //  监听路由变化时的状态为前进还是后退
      console.log(from.meta.index, to.meta.index);
      if (to.meta.index && from.meta.index) {
        if (to.meta.index > from.meta.index) {
          // 设置动画名称
          this.transitionName = 'slide-left';
        } else {
          this.transitionName = 'slide-right';
        }
        return;
      }
      if (isBack) {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = 'slide-left';
      }
      this.$router.isBack = false;
    }
  },
  created: function created() {
    localStorage.removeItem('searchActiveName');
    var params = {
      page: 1,
      perPage: 5
    };
    this.getHotSearchList(params);
    topicParams['filter[content]'] = '';
    this.getTopicList(topicParams);
    // threadListParams.page = 1
    // this.getThreadList(threadListParams)
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.$refs.inputs.focus();
      // const that = this
      // $(window).on('click', (e) => {
      //   console.log(e.target)
      //   if (e.target === that.$refs.inputs) {
      //     return
      //   }
      //   that.$refs.inputs.blur()
      //   that.$toast(666)
      // })
    });
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {
    toAllTopic: function toAllTopic() {
      this.$router.push({
        path: '/social/allTopic'
      });
    },
    toTopic: function toTopic(topicId) {
      this.$router.push({
        path: '/social/topic',
        query: {
          topicId: topicId
        }
      });
    },
    getTopicList: function getTopicList(params) {
      var _this2 = this;
      topicList(params).then(function (res) {
        if (res.Code === 0) {
          _this2.hotTopicList = res.Data.pageData;
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    clearHistory: function clearHistory() {
      localStorage.removeItem('historySearchList');
      this.historySearchList = [];
    },
    getHotSearchList: function getHotSearchList(params) {
      var _this3 = this;
      recommendKeywords(params).then(function (res) {
        if (res.Code === 0) {
          _this3.hotSearchList = res.Data.pageData;
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    getResult: function getResult(value) {
      var _this4 = this;
      if (value === '') {
        value = 'ZS EV';
      }
      if (value.trim()) {
        this.value = value.trim();
        if (localStorage.getItem('historySearchList')) {
          var arr = JSON.parse(localStorage.getItem('historySearchList'));
          console.log(arr, 'arr');
          var flag = arr.every(function (item) {
            return item !== value.trim();
          });
          if (flag) {
            arr.push(value.trim());
          }
          if (arr.length > 5) {
            arr = arr.slice(-5);
          }
          localStorage.setItem('historySearchList', JSON.stringify(arr));
        } else {
          var _arr = [];
          _arr.push(value.trim());
          localStorage.setItem('historySearchList', JSON.stringify(_arr));
        }
        var timer = setTimeout(function () {
          _this4.isResults = true;
          _this4.isInput = false;
          _this4.$nextTick(function () {
            $(_this4.$refs.tabs.$el).height($(window).height() - $('.input-con').innerHeight() - getPx(102) - $('.van-tabs__wrap').height());
          });
          _this4.inputValue = value;
          _this4.activeName = localStorage.getItem('searchActiveName') || 'All';
          _this4.tabChange(_this4.activeName);
          // this.$router.replace('/social/search/all')
          clearTimeout(timer);
        }, 100);
      }
    },
    tabChange: function tabChange(name) {
      // 1=Club，2=Acitivity，3=Video，4=News
      localStorage.setItem('searchActiveName', name);
      this.activeName = name;
      var path = name.toLowerCase();
      this.$router.replace({
        path: "/social/search/".concat(path)
      });
      // const index = this.arr.indexOf(name)
      // if (index === 0) {
      //   delete threadListParams['filter[categoryids][0]']
      // } else {
      //   threadListParams['filter[categoryids][0]'] = index
      // }
      // threadListParams['filter[search]'] = this.value
      // this.getThreadList(threadListParams)
      // localStorage.setItem('activeName', name)
    },
    toDetail: function toDetail() {
      this.$router.push({
        path: '/social/detail',
        query: {
          from: 'activity'
        }
      });
    },
    clear: function clear() {
      this.value = '';
      this.isInput = false;
      this.isResults = false;
      this.isEmpty = true;
    },
    input: function input(value) {
      if (value.trim()) {
        if (localStorage.getItem('historySearchList')) {
          this.findList = JSON.parse(localStorage.getItem('historySearchList')).filter(function (item) {
            console.log(item, 'item');
            return item.indexOf(value.trim()) !== -1;
          });
          console.log(this.findList, 'this.findList');
        }
        this.isInput = true;
        this.isEmpty = false;
      } else {
        this.isResults = false;
        this.isInput = false;
        this.isEmpty = true;
      }
    }
  }
};